import axios from "axios";

const WP_URL = process.env.REACT_APP_WP_URL || "http://localhost:8080"; // Fallback placeholder

// WooCommerce Store API (Public, unauthenticated, designed for headless stores)
export const wcApi = axios.create({
  baseURL: `${WP_URL}/wp-json/wc/store/v1`,
});

// CoCart API (For managing the cart session)
export const cocartApi = axios.create({
  baseURL: `${WP_URL}/wp-json/cocart/v2`,
  withCredentials: true, // Needed if you want to use cookies for session
});

export const getCheckoutUrl = (cartKey) => {
  return `${WP_URL}/checkout?cocart-load-cart=${cartKey}`;
};
